import React from 'react';
import {connect} from 'react-redux';
import DataTable from 'react-data-table-component';
import Message from '../layout/Message';
import Button from '../layout/Button';

import {
    fetchPianoTechUserList,
    FIND_PIANOTECHUSER_STARTED,
    FIND_PIANOTECHUSER_SUCCEEDED,
    findPianoTechUser,
} from '../../actions/PianoTechUserActions';

import {
    MAINTENANCE_TYPE_VIEW,
    MAINTENANCE_TYPE_ADD,
    defaultPianoTechUser,
} from '../../app-constants';

const mapStateToProps = state => ({
    pianoTechUser: state.pianoTechUser,
    user: state.user,
});

class PianoTechUserTable extends React.PureComponent {
    componentDidMount() {
        //Retrieve list if they are not in state
        if (!this.props.pianoTechUser.pianoTechUserList || this.props.pianoTechUser.pianoTechUserList.length === 0)
            this.props.dispatch(fetchPianoTechUserList());
    }

    refreshList = () => {
        this.props.dispatch(fetchPianoTechUserList());
    }

    addPianoTechUser = () => {
        const originalPianoTechUser = Object.assign({}, defaultPianoTechUser);
        const pianoTechUser = Object.assign({}, defaultPianoTechUser);
        
        this.props.dispatch({
            type: FIND_PIANOTECHUSER_STARTED,
            maintenanceType: MAINTENANCE_TYPE_ADD,
            title: "Add PianoTechUser",
        });
        
        this.props.dispatch({
            type: FIND_PIANOTECHUSER_SUCCEEDED,
            pianoTechUser,
            originalPianoTechUser,
        });
        
    }

    viewPianoTechUser(userId) {
        this.props.dispatch({
            type: FIND_PIANOTECHUSER_STARTED,
            maintenanceType: MAINTENANCE_TYPE_VIEW,
            title: "View PianoTechUser",
        });
        
        this.props.dispatch(findPianoTechUser(userId));
    }

    render() {
        const columns = [
                    {
                        name: 'User Id',
                        selector: row => row.userId,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Login Id',
                        selector: row => row.loginId,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Encrypted Password',
                        selector: row => row.encryptedPassword,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'User Name',
                        selector: row => row.userName,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'User Email',
                        selector: row => row.userEmail,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Admin User',
                        selector: row => row.adminUser,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Require New Password',
                        selector: row => row.requireNewPassword,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Locked Out',
                        selector: row => row.lockedOut,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Current Invalid Login Attempts',
                        selector: row => row.currentInvalidLoginAttempts,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Lifetime Invalid Login Attempts',
                        selector: row => row.lifetimeInvalidLoginAttempts,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Buttons',
                        width: '8%',
                        cell: row =>
                        (
                            <>
                                <button
                                    className="bluebutton"
                                    onClick={() => { this.viewPianoTechUser(row.userId) }}
                                    style={{ marginRight: "5px" }}
                                    >View
                                </button>
                            </>
                        )
                    },
        ]
        const customStyles = {
            rows: {
                style: {
                    minheight: '20px',
                }
            }
        }

        return (
        <div>
            <Message message={this.props.pianoTechUser.message} type={this.props.pianoTechUser.messageType} />
            <table width="100%">
                <tbody>
                    <tr>
                        <td className='lefttext'>
                            <Button className="bluebutton" description="Refresh" onClick={this.refreshList} />
                        </td>
                        {this.props.user.allowAdd &&
                            <td className='righttext'>
                                <Button className="bluebutton" description="Add PianoTechUser" onClick={this.addPianoTechUser} />
                            </td>
                        }
                    </tr>
                </tbody>
            </table>
            <DataTable
                title='PianoTechUser'
                className='app-table'
                columns={columns}
                customStyles={customStyles}
                striped
                data={this.props.pianoTechUser.pianoTechUserList}
                defaultSortField="loginId"
                highlightOnHover
                pagination
                onRowClicked={
                    (row) => { this.viewPianoTechUser(row.userId) }
                }
            />
        </div>
        );
    }

}

export default connect(mapStateToProps)(PianoTechUserTable);
